import React, { useEffect, useState } from 'react';
import { Card, CardBody, Button, Table, Badge, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import InputRoleModal from '../../components/common/InputRoleModal';
import ConfirmModal from '../common/ConfirmModal';
import LoaderButton from '../loader-button/LoaderButton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
// services
import BZAPIService from '../../services/BZAPIService';

// libs
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// const
const ADMIN_ROLE_ID = 1;

const newRole = { name: '', rbacPermissions: [], isDefault: false };
const RBACRoles = () => {
  const [rbacRoles, setRbacRoles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderRoleId, setLoaderRoleId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState(newRole);
  const [isReadOnly, setIsReadOnly] = useState(true);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const apiRbacRolesPromise = BZAPIService.getRbacRoles();
        const apiVendorsPromise = BZAPIService.getVendors();
        const myUserPermissionsPromise = BZAPIService.getMyUserPermissions();
        const [apiRbacRoles, apiVendors, myUserPermissions] = await Promise.all([
          apiRbacRolesPromise,
          apiVendorsPromise,
          myUserPermissionsPromise
        ]);
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));

        setIsLoading(false);

        console.log('apiRbacRoles', apiRbacRoles);
        console.log('apiVendors', apiVendors);
        setRbacRoles(apiRbacRoles ? apiRbacRoles : []);

        setVendors(apiVendors ? apiVendors?.filter(vendor => vendor?.active && vendor.type === 'vendor') : []);
      } catch (e) {
        console.log(e);
      }
    }
    onLoad();
    // console.log('api', aws.apiGateway.URL);
  }, []);
  const handleEditRole = async roleId => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      setLoaderRoleId(roleId);
      // Create new Open API Role
      const apiRbacRole = (await BZAPIService.getRbacRole(roleId)) || {};
      setSelectedRole(apiRbacRole);
      setModalOpen(true);
      setLoader(false);
      setLoaderRoleId(null);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      setLoaderRoleId(null);
      toast.error('Failed to load role');
    }
  };
  const handleConfirmDelete = async roleId => {
    const apiRbacRole = (await BZAPIService.getRbacRole(roleId)) || {};
    setSelectedRole(apiRbacRole);
    setShowAlert(true);
  };
  const handleDelete = async roleId => {
    setLoader(true);

    try {
      // Create new Open API Role
      await BZAPIService.deleteRbacRole(roleId);
      toast.success('Role deleted');
      const apiRbacRoles = (await BZAPIService.getRbacRoles()) || {};
      setRbacRoles(apiRbacRoles ? apiRbacRoles : []);
      setLoader(false);
      setShowAlert(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      setShowAlert(false);
      toast.error('Failed to load role');
    }
  };
  const handleCreateRole = async () => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API Role
      setSelectedRole({ ...newRole });
      setModalOpen(true);
      setLoader(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      toast.error('Failed to load role');
    }
  };

  const updateRole = async payload => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API Role
      await BZAPIService.updateRbacRole(selectedRole.id, payload);
      toast.success('Role updated');
      const apiRbacRoles = (await BZAPIService.getRbacRoles()) || {};
      setRbacRoles(apiRbacRoles ? apiRbacRoles : []);
      setLoader(false);
      setModalOpen(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      toast.error('Failed to update role');
    }
  };
  const createRole = async payload => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API Role
      await BZAPIService.createRbacRole(payload);
      toast.success('Role created');
      const apiRbacRoles = (await BZAPIService.getRbacRoles()) || {};
      setRbacRoles(apiRbacRoles ? apiRbacRoles : []);
      setLoader(false);
      setModalOpen(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      toast.error('Failed to create role');
    }
  };

  if (isLoading && !isSubmitted) return <Loader text="Loading roles..." />;
  return (
    <>
      <Heading
        title="BugZero user roles and permissions"
        subtitle="Manage roles and permissions for users"
        className="mb-4 mt-3"
        icon="cog"
      />
      {isReadOnly && (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      )}

      <Card>
        <CardBody className="fs--1">
          <div className="row">
            <div className="col text-right">
              <a
                href={`/documentation/user-guides/rbac-guide`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-falcon-default ml-2 btn-sm"
                data-testid={'integration-link'}
              >
                <FontAwesomeIcon icon="book" className="mr-2" />
                BugZero RBAC guide
              </a>
            </div>
          </div>
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Name</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rbacRoles?.length ? (
                rbacRoles.map(role => {
                  return (
                    <tr key={role.id} id={role.id} className="font-weight-bold" data-testid={'role-row'}>
                      <td>
                        <div className="py-2">
                          {role.name}
                          {'  '} {!!role.isDefault && <Badge color="secondary">Default</Badge>}
                        </div>
                      </td>
                      <td>
                        <div className="py-2" data-testid={'role-created-date'}>
                          {role.createdAt}
                        </div>
                      </td>
                      <td>
                        {role.id !== ADMIN_ROLE_ID && (
                          <>
                            {' '}
                            <LoaderButton
                              isLoading={loaderRoleId === role.id}
                              onClick={() => handleEditRole(role.id)}
                              value={role.id}
                              name={role.name}
                              size="sm"
                              color="falcon-primary"
                              data-testid={'role-create-alert'}
                            >
                              <FontAwesomeIcon icon={'edit'} value={role.id} />
                            </LoaderButton>
                            {'   '}
                            <Button
                              onClick={e => handleConfirmDelete(role.id)}
                              value={role.id}
                              disabled={isReadOnly}
                              name={role.name}
                              color="falcon-danger"
                              data-testid={'role-delete-alert'}
                            >
                              <FontAwesomeIcon icon={'trash'} value={role.id} />
                            </Button>
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>You have no user roles yet</td>
                  <td />
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
          <div className="text-right">
            <Button
              color="falcon-primary"
              className="btn-sm"
              disabled={isReadOnly}
              onClick={handleCreateRole}
              data-testid={'input-modal-cta'}
            >
              Create Role
            </Button>

            <InputRoleModal
              isReadOnly={isReadOnly}
              selectedRole={selectedRole}
              setSelectedRole={setSelectedRole}
              isSubmitted={isSubmitted}
              setIsSubmitted={setIsSubmitted}
              modalOpen={modalOpen}
              vendors={vendors}
              setModalOpen={setModalOpen}
              setIsLoading={setIsLoading}
              createRole={createRole}
              updateRole={updateRole}
              loader={loader}
            />
            <ConfirmModal
              name={selectedRole.name}
              value={selectedRole.id}
              confirmCallback={handleDelete}
              showAlert={showAlert}
              setShowAlert={setShowAlert}
              loader={loader}
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default RBACRoles;
